export const INIT_OCTOKIT = "INIT_OCTOKIT";
export const CLEAR_REPOSITORIES = "CLEAR_REPOSITORIES";
export const LOAD_PUBLIC_REPOSITORIES = "LOAD_PUBLIC_REPOSITORIES";
